import { render, staticRenderFns } from "./InvestmentManagerIndex.vue?vue&type=template&id=b3120152&"
import script from "./InvestmentManagerIndex.vue?vue&type=script&lang=js&"
export * from "./InvestmentManagerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports